import { ButtonGhost } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const CreateNewCategory = styled(ButtonGhost)`
  justify-content: flex-start;
  padding: 12px 24px;
  width: 100%;
  height: auto;
`
